import { LayoutWithNavigationBar } from "../../../layouts/layout-with-navigation-bar";
import { MainView } from "../../../views/inbound/scan-completed";

export default function Inbound_Scan_CompletedPage(props) {
    return (
        <>
            <LayoutWithNavigationBar>
                <MainView />
            </LayoutWithNavigationBar>
        </>
    );
}